/// <reference path="../../Scripts/Public/jquery-1.6.2.min.js" />
/// <reference path="../../Scripts/Public/AJAX.js" />
/// <reference path="../../Scripts/Public/General.js" />
/// <reference path="../../Scripts/Public/Security.js" />
/// <reference path="../../Scripts/Public/ServiceURL.js" />
/// <reference path="../SumoDataAccess.js" />
/// <reference path="../SumoClass.js" />

if (typeof jQuery === 'undefined') {
    throw (this.className() + ' requires jquery-1.6.2.*.js');
}

if (isNullOrUndefined(sumo)) {
    throw ('ControlBase.js requies the sumo namespace defined in SumoClass.js');
}

if (isNullOrUndefined(sumo.controls)) {
    sumo.controls = {};
}

// ControlBase Constructor Options (this.Options)
// OnRender: callback event that is called after the control has rendered.
//           see sumo.Class for info on bind()

// public properties
//   Id
//   ParentId
//   Html
//   Options

// triggered events
// 'render'
/** @namespace */
sumo.controls.ControlBase = function (aId, aParentId, aHtml, aOptions) {
    "use strict";

    sumo.controls.ControlBase.prototype.baseClass.call(this);

    this.IsControlVisible = true;
    this.IsParentVisible = true;

    this.Id = null;
    this.ParentId = null;
    this.ParentElement = null;
    this.ControlElement = null;
    this.Html = null;
    this.Options = null;

    if (!this.isNothing(arguments) && arguments.length > 0) {
        this.Id = aId;
        this.Options = aOptions;

        this.Html = aHtml.replace(/##id##/g, this.Id);

        if (typeof aParentId === 'string') {
            this.ParentId = aParentId;
            this.ParentElement = $('#' + this.ParentId);
        } else {
            this.ParentId = aParentId.id;
            this.ParentElement = $(aParentId);
        }
        this.ParentElement.html(this.Html);

        this.ControlElement = this.ParentElement.find('#' + this.Id);
        this.ControlElement.data('control', this);
    }

    // must override
    this.render = function () {
        throw (this.className() + ' must overload render()');
    };

    // overridable
    this.dispose = function () {
        if (!this.isNothing(this.Options) && !this.isNothing(this.Options.OnRender)) {
            this.unbind('render', this.Options.OnRender);
        }
        if (!this.isNothing(this.ParentElement)) {
            this.ParentElement.html('');
        }

        this.ParentElement = null;
        this.ControlElement = null;
        this.Html = null;
        this.Options = null;
        this.Id = null;
        this.ParentId = null;

        sumo.controls.ControlBase.prototype.dispose.call(this);
    };

    this.show = function () {
        if (!this.IsControlVisible) {
            this.IsControlVisible = true;
            this.ControlElement.show();
        }
    };

    this.hide = function () {
        if (this.IsControlVisible) {
            this.IsControlVisible = false;
            this.ControlElement.hide();
        }
    };

    this.showParent = function () {
        if (!this.IsParentVisible) {
            this.IsParentVisible = true;
            this.ParentElement.show();
        }
    };

    this.hideParent = function () {
        if (this.IsParentVisible) {
            this.IsParentVisible = false;
            this.ParentElement.hide();
        }
    };

    if (!this.isNothing(this.Options) && !this.isNothing(this.Options.OnRender)) {
        this.bind('render', this.Options.OnRender, null);
    }
};
sumo.controls.ControlBase.prototype = new sumo.Class();
sumo.controls.ControlBase.prototype.constructor = sumo.controls.ControlBase;
sumo.controls.ControlBase.prototype.baseClass = sumo.Class;